var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"0"}},[_c('div',{staticClass:"enable",class:[
      _vm.validationClass,
      _vm.animationErrorClass,
      _vm.value
        ? `${_vm.classes} checked`
        : _vm.classes,
    ],attrs:{"data-checkbox":_vm.dataset},on:{"click":_vm.onToggle}},[_c('div',{staticClass:"checkbox__title"},[_vm._t("default"),_vm._v(" "),(_vm.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()],2),_vm._v(" "),_c('div',{class:_vm.validationClass})]),_vm._v(" "),(_vm.isShow && _vm.error)?_c('div',{staticClass:"form-error"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }